import React from "react";
import { Checkbox } from "./Checkbox";

interface Props {
    name: string;
    label?: string;
    options: {
        label: string;
        value: string;
        defaultChecked?: boolean;
    }[];
}

export const CheckboxList = (props: Props) => {
    const { name, options, label } = props;

    return (
        <fieldset className="mb-6">
            <strong className="block text-brand-primary-dim mb-2">{label}</strong>
            <div className="inline-flex flex-row w-full">
                {options?.map((option, index) => (
                    <span key={index} className={`inline-flex items-center text-lg text-neutral-40 ${index !== 0 ? "ml-6" : null}`}>
                        <Checkbox
                            id={name + "_" + option.value}
                            name={name}
                            label={option.label}
                            value={option.value}
                            defaultChecked={option.defaultChecked}
                        />
                    </span>
                ))}
            </div>
        </fieldset>
    );
};
